<script setup lang="ts">
import Point from '@/models/point';

const props = defineProps<{ 
  point: Point,
  selectedPoint: Point | null,
  isFirst: boolean,
  isLast: boolean
}>();

const emit = defineEmits<{
  (e: 'selectPoint', point: Point): void,
}>()

</script>

<template>

  <div class="point-item__wrapper" :style="{'box-shadow': !isLast ? '0 0.5px 0 #C8C7CB' : ''}" @click="emit('selectPoint', props.point)">
    <p class="point__name">{{ props.point.name }}</p>
    <img class="point__ckecker" v-if="props.selectedPoint?.id === props.point.id" src="@/assets/check.svg">
    <img class="point__ckecker" v-else src="@/assets/uncheck.svg">
  </div>

</template>

<style scoped>

.point__ckecker {
  width: 25px;
  display: flex;
}

.point__name {
  font-size: 18px;
  color: black;
}

.point-item__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 0;
}

</style>